
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Badge } from '../components/ui/badge';
import { ShieldCheck } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="py-20 bg-gradient-to-br from-blue-50 to-teal-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center space-y-4 mb-12">
            <Badge className="bg-teal-100 text-teal-700 hover:bg-teal-100 px-4 py-1 border-0 mx-auto">
              <ShieldCheck className="w-4 h-4 mr-2 inline" />
              <span className="font-medium">Your Privacy Matters</span>
            </Badge>
            <Badge className="bg-teal-100 text-teal-700 hover:bg-teal-100 px-4 py-1 border-0 mx-auto">
  <ShieldCheck className="w-4 h-4 mr-2 inline" />
  <span className="font-medium">Your Privacy Matters</span>
</Badge>

{/* Hidden SEO Keywords */}
<div className="hidden-keywords">
  {/* General API & Trade Keywords */}
  <span>API manufacturer India</span>
  <span>Pharmaceutical API supplier India</span>
  <span>Active pharmaceutical ingredient manufacturer</span>
  <span>Bulk drug manufacturer India</span>
  <span>API exporter India</span>
  <span>API supplier for pharmaceutical companies</span>
  <span>Pharmaceutical raw material supplier</span>
  <span>High purity API manufacturer</span>
  <span>GMP API manufacturer India</span>
  <span>API manufacturing company India</span>

  {/* Hormone & Testosterone Keywords */}
  <span>Hormone API manufacturer India</span>
  <span>Steroid API manufacturer India</span>
  <span>Hormone API supplier</span>
  <span>Injectable hormone API supplier</span>
  <span>Testosterone API manufacturer</span>
  <span>Testosterone raw material supplier</span>
  <span>Injectable testosterone API</span>

  {/* Vitamin & Antibiotic Keywords */}
  <span>Vitamin API manufacturer India</span>
  <span>Vitamin B complex API supplier</span>
  <span>Pharmaceutical vitamin ingredient supplier</span>
  <span>Antibiotic API manufacturer India</span>
  <span>Antibiotic bulk drug supplier</span>
</div>
            <h1 className="text-5xl font-bold">
              <span className="text-gray-900">Privacy </span>
              <span className="bg-gradient-to-r from-blue-600 to-teal-500 bg-clip-text text-transparent">Policy</span>
            </h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-12 space-y-8">

            <section className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                Vigyan Healthcare is committed to protecting your privacy and ensuring the security of your personal and business information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">1. Information We Collect</h2>

              <p className="text-gray-700 leading-relaxed">
                We may collect the following types of information:
              </p>

              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>
                  Personal identifiable information such as name, postal address, email address, telephone number, or any other identifier by which you may be contacted online or offline when you provide it to us.
                </li>

                <li>
                  Information about your internet connection, the equipment you use to access our website, and usage details.
                </li>

                <li>
                  Business information when you register as a distributor or business partner.
                </li>
              </ul>
            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">2. How We Use Your Information</h2>

              <p className="text-gray-700 leading-relaxed">
                Vigyan Healthcare may use collected information to:
              </p>

              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Respond to inquiries and business requests</li>
                <li>Provide product details (APIs, Chemicals, Bulk Drugs)</li>
                <li>Send quotations and business proposals</li>
                <li>Improve website performance</li>
                <li>Comply with legal and regulatory obligations</li>
                <li>Enhance customer service experience</li>
              </ul>

              <p className="text-gray-700 leading-relaxed">
                We do not sell, rent, or trade your personal information to third parties.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">3. Cookies Policy</h2>

              <p className="text-gray-700 leading-relaxed">
                Our website may use cookies to enhance user experience and analyze website traffic. You can choose to disable cookies through your browser settings.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">4. Data Protection & Security</h2>

              <p className="text-gray-700 leading-relaxed">
                We implement appropriate technical and organizational security measures to protect your personal data from unauthorized access, misuse, or disclosure.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">5. Third-Party Disclosure</h2>

              <p className="text-gray-700 leading-relaxed">
                We may share information with:
              </p>

              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Regulatory authorities (if required by law)</li>
                <li>Logistics and shipping partners</li>
                <li>Payment processing partners</li>
                <li>IT and website service providers</li>
              </ul>

              <p className="text-gray-700 leading-relaxed">
                All third parties are obligated to maintain confidentiality.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">6. International Data Transfers</h2>

              <p className="text-gray-700 leading-relaxed">
                As a pharmaceutical API exporter, Vigyan Healthcare may transfer information internationally for business purposes while ensuring compliance with applicable data protection laws.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">7. Your Rights</h2>

              <p className="text-gray-700 leading-relaxed">
                Depending on your location, you may have rights to:
              </p>

              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Withdraw consent at any time</li>
              </ul>

              <p className="text-gray-700 leading-relaxed">
                To exercise these rights, contact us at the details below.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">8. Data Retention</h2>

              <p className="text-gray-700 leading-relaxed">
                We retain business and personal information only as long as necessary for legitimate business purposes and regulatory compliance.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">9. Changes to This Policy</h2>

              <p className="text-gray-700 leading-relaxed">
                Vigyan Healthcare reserves the right to update this Privacy Policy at any time. Updates will be posted on this page.
              </p>

            </section>


            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">10. Contact Us</h2>

              <p className="text-gray-700 leading-relaxed">
                If you have any questions regarding this Privacy Policy, please contact:
              </p>

              <div className="bg-blue-50 rounded-lg p-4 space-y-2">
                <p className="text-gray-700"><strong>Email:</strong> vigyanhealthcare@gmail.com</p>
                <p className="text-gray-700"><strong>Phone:</strong> +91 9630935265</p>
                <p className="text-gray-700">
                  <strong>Address:</strong> 18/103/3, A B Road, Lasudiya Mori, Vijay Nagar, Indore-452010, Madhya Pradesh, India
                </p>
              </div>

            </section>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;